module.exports = __webpack_public_path__ + "static/media/work.4234d723.fe71bbc4.svg";